import React from 'react';

const WeeklyCalendar = ({ weeklyLog, summary, settings }) => {
  if (!weeklyLog || !Array.isArray(weeklyLog)) return null;

  const totalDist = summary ? summary.totalCompleted : 0;
  const targetDist = settings ? settings.weeklyTarget : 40;
  const percent = Math.min(100, (parseFloat(totalDist) / parseFloat(targetDist)) * 100);

  return (
    <div className="bg-gray-800 rounded-xl p-6 border border-gray-700 col-span-1 md:col-span-2 lg:col-span-3">
        <div className="flex justify-between items-end mb-4">
             <div>
                 <h3 className="text-gray-400 text-xs uppercase tracking-wider">Weekly Training</h3>
                 <p className="text-xl font-bold text-white mt-1">
                    {totalDist} <span className="text-gray-500 font-normal">/ {targetDist} km</span>
                 </p>
             </div>
             {/* Simple progress bar */}
             <div className="w-1/3 max-w-xs">
                 <div className="h-2 bg-gray-700 rounded-full overflow-hidden">
                     <div 
                        className="h-full bg-blue-500 rounded-full" 
                        style={{ width: `${percent}%` }}
                     ></div>
                 </div>
             </div>
        </div>

        {/* 7-Day Grid */}
        <div className="grid grid-cols-7 gap-2">
            {weeklyLog.map((day, idx) => {
                const isCompleted = day.status === 'COMPLETED' || day.status === 'REST_COMPLETED'; // Updated status checks
                const isMissed = day.status === 'MISSED';
                const isRest = day.planType.toLowerCase().includes('rest');
                const isToday = day.isToday;

                return (
                    <div key={idx} className={`p-2 rounded-lg border flex flex-col items-center justify-center min-h-[80px] relative ${
                        isToday ? 'bg-gray-700/50 border-blue-500/50' : 'bg-gray-900/30 border-gray-700'
                    }`}>
                        <span className="text-xs text-gray-500 uppercase">{day.dayName}</span>
                        
                        {isRest ? (
                            <span className="text-xl mt-1 opacity-50">🛏️</span>
                        ) : isCompleted && day.distance ? (
                            <div className="text-center mt-1">
                                <span className="text-xl">✅</span>
                                <p className="text-xs text-gray-300 font-medium">{day.distance}</p>
                            </div>
                        ) : isMissed ? (
                            <div className="text-center mt-1">
                                <span className="text-xl">❌</span>
                                <span className="text-xs text-red-400">Missed</span>
                            </div>
                         ) : (
                            <div className="text-center mt-1">
                                <span className="text-xs font-semibold text-gray-400">{day.planType}</span>
                                <p className="text-xs text-gray-500">-</p>
                            </div>
                        )}
                        
                        {/* Status dot */}
                        <div className={`w-2 h-2 rounded-full absolute top-2 right-2 ${
                            day.emoji === '🟢' ? 'bg-green-500' : 
                            day.emoji === '🔴' ? 'bg-red-500' :
                            day.emoji === '🟠' ? 'bg-orange-400' :
                            day.emoji === '🔵' ? 'bg-blue-400' : 'bg-gray-600'
                        }`}></div>
                    </div>
                );
            })}
        </div>
    </div>
  );
};

export default WeeklyCalendar;
